import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";

// audiosprite --e "mp3,ogg" --o ../../assets/audio/sound *.mp3 --f howler
// audiosprite --e "mp3,ogg" --o ../../assets/audio/music *.mp3 --f howler
export class AudioManager {

    public static sound: Howl;
    public static music: Howl;

    private static musicKey: string;
    private static musicId: number;
    private static busId: number;
    private static cardsTimestamp: number;

    public static init(): void {

        AudioManager.sound.mute(GameVars.gameData.soundMuted);
        AudioManager.music.mute(GameVars.gameData.musicMuted);

        AudioManager.cardsTimestamp = Date.now();
    }

    public static toggleSoundState(): void {

        GameVars.gameData.soundMuted = !GameVars.gameData.soundMuted;
        GameManager.writeGameData();
        
        AudioManager.sound.mute(GameVars.gameData.soundMuted);
    }

    public static toggleMusicState(): void {

        GameVars.gameData.musicMuted = !GameVars.gameData.musicMuted;
        GameManager.writeGameData();
        
        AudioManager.music.mute(GameVars.gameData.musicMuted);
    }

    public static playSound(key: string, loop?: boolean, volume?: number): void {

        if (key === "cards_in" || key === "cards_out") {
            if (Date.now() - 75 < AudioManager.cardsTimestamp) {
                return;
            } else {
                AudioManager.cardsTimestamp = Date.now();
            }
        }

        loop = loop || false;
        volume = volume || 1;

        const id = AudioManager.sound.play(key);

        if (key === "bus_move") {
            AudioManager.busId = id;
        }
        
        AudioManager.sound.volume(volume, id);
        AudioManager.sound.loop(loop, id);
    }

    public static stopSound(): void {

        AudioManager.sound.fade(1, 0, 200, AudioManager.busId);
    }

    public static playMusic(key: string, volume?: number): void {

        volume = volume || 1;

        if (key !== AudioManager.musicKey) {
            AudioManager.musicId = AudioManager.music.play(key);
            AudioManager.sound.loop(true, AudioManager.musicId);
            AudioManager.musicKey = key;
        } 
        
        AudioManager.music.volume(volume, AudioManager.musicId);
    }

    public static onBlur(): void {
        
        if (!GameVars.gameData.soundMuted && AudioManager.sound) {
            AudioManager.sound.mute(true);
        }

        if (!GameVars.gameData.musicMuted && AudioManager.music) {
            AudioManager.music.mute(true);
        }
    }

    public static onFocus(): void {
        
        if (!GameVars.gameData.soundMuted && AudioManager.sound) {
            AudioManager.sound.mute(false);
        }

        if (!GameVars.gameData.musicMuted && AudioManager.music) {
            AudioManager.music.mute(false);
        }
    }
}
